import { useMemo, useRef, useEffect, useState } from "react"; // added useState
import { motion } from "framer-motion";
import {
  useStep,
  usePlan,
  useMealType,
  useMealsSelection,
} from "../contexts/SubscriptionContext";
import Icon from "../common/Icon"; // 👈 your custom icon component
import Address from "./Address";
import PromoCodeSection from "./PromoCodeSection";
import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import CartSummary from "../shopPartials/CartSummary";
import TopStepsStatus from "./TopStepsStatus";
import AddressForRenew from "./AddressForRenew";
import { isSnack } from "../utils/commonHelper";
import GeneralButton from "../common/GeneralButton";

const Checkout = () => {
  const { goToStep } = useStep();
  const { cart, fetchCart } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const renew = params.get("renew");

  const [loadingCart, setLoadingCart] = useState(true); // NEW

  useEffect(() => {
    goToStep("4");

    if (!cart?.mealCart && !cart?.orderCart) {
      fetchCart().finally(() => setLoadingCart(false));
    } else {
      setLoadingCart(false);
    }
  }, []);

  return (
    <>
      {renew != "true" && <TopStepsStatus url={""} rightText="" />}

      {!loadingCart && !cart?.mealCart ? (
        <motion.div
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -200, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div className="bg-[#DEE2DD]/40  w-full rounded-[15px] p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[70px] mt-10 mb-2">
            <div className="w-full  p-5 text-center  flex flex-col items-center justify-center ">
              <h2 className="text-[32px] mb-1">Something went wrong!</h2>
              <p className="text-orange text-17pt font-mono mb-1">
                Your meal subscription cart is not available.
              </p>
              <p className="text-orange text-17pt font-mono mb-4">
                Please start the process again.
              </p>
              <GeneralButton
                onClick={() => {
                  navigate("/plans");
                }}
                text="Start Again"
                title=""
                icon={null}
                bgColor="#D06F36"
                textColor="#fff"
                className="text-18pt"
              />
            </div>
          </div>
        </motion.div>
      ) : (
        <>
          <motion.div
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -200, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <p
              className={`text-34pt  ${renew != "true" ? "mt-4 lg:mt-9 pb-4 lg:pb-9 " : "pb-4 lg:pb-8"}`}
            >
              Checkout
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-1 2xl:grid-cols-[25.5fr_1fr] 2.5xl:grid-cols-[11.5fr_1fr] gap-8 items-start">
              <div>
                <div className="bg-[#DEE2DD]/40  w-full rounded-[15px] p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[70px] mb-10">
                  <p className=" text-green text-21pt">
                    Review all items before proceeding to checkout
                  </p>
                  <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] 2.5xl:grid-cols-[1.08fr_0.805fr] gap-5 md:gap-10 2.5xl:gap-24 mt-8 items-start">
                    <div className="grid grid-cols-1 gap-5 md:gap-10 ">
                      <div className="grid grid-cols-[3.5fr_1fr] bg-[#fff] min-h-[120px] rounded-[15px] px-8 py-4">
                        <div className="flex items-start justify-center flex-col">
                          <p className=" text-24pt md:text-48pt leading-none">
                            {cart?.mealCart?.plan?.title}
                          </p>
                          <p className="text-24pt md:text-32pt">plan</p>
                        </div>
                        {renew != "true" && (
                          <div
                            className="flex items-center justify-end"
                            onClick={() => {
                              goToStep("1");
                              navigate("/subscribe/plan");
                            }}
                          >
                            <Icon
                              icon="edit"
                              className="w-[32px] h-[30px] text-green hover:text-secondary cursor-pointer"
                              title="Click to change plan"
                            />
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-[3.5fr_1fr] bg-[#fff] min-h-[120px] rounded-[15px] px-8 py-4">
                        <div className="flex items-start justify-center flex-col">
                          <p className="text-24pt md:text-32pt leading-none">
                            Meals preference
                          </p>
                          <p className="text-24pt md:text-32pt text-quaternary">
                            {cart?.mealCart?.vegOrNonVeg === "Non Veg"
                              ? "Non-vegetarian"
                              : "Vegetarian"}
                          </p>
                        </div>
                        {renew != "true" && (
                          <div
                            className="flex items-center justify-end"
                            onClick={() => {
                              navigate("/subscribe/plan");
                              goToStep("1.1");
                            }}
                          >
                            <Icon
                              icon="edit"
                              className="w-[32px] h-[30px] text-green hover:text-secondary cursor-pointer"
                              title="Click to change meal preference"
                            />
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-[2fr_1fr] md:grid-cols-[5fr_1fr] bg-[#fff] min-h-[120px] rounded-[15px] px-8 py-4">
                        <div className="flex items-start justify-center flex-col">
                          <p className="text-24pt md:text-32pt leading-none">
                            Meals
                          </p>
                          <p className="text-21pt md:text-32pt text-quaternary">
                            {cart?.mealCart?.meals?.length > 0
                              ? cart?.mealCart?.meals
                                  ?.map((meal) =>
                                    isSnack(meal?.title)
                                      ? "Snacks"
                                      : meal?.title,
                                  )
                                  .join(" + ")
                              : "None selected"}
                          </p>
                        </div>
                        {renew != "true" && (
                          <div
                            className="flex items-center justify-end"
                            onClick={() => {
                              navigate("/subscribe/meals");
                              goToStep("2");
                            }}
                          >
                            <Icon
                              icon="edit"
                              className="w-[32px] h-[30px] text-green hover:text-secondary cursor-pointer"
                              title="Click to change meals"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <CartSummary cart={cart?.mealCart} />
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
          {renew === "true" ? (
            <AddressForRenew
              onNext={() => navigate("/payment/meals?renew=true")}
            />
          ) : (
            <Address onNext={() => navigate("/payment/meals")} />
          )}
        </>
      )}
    </>
  );
};

export default Checkout;
